export default "__VITE_ASSET__Xhl423dn__"